import React from 'react';

import { BookingsCurrentChina } from '@components/admin/booking/BookingsCurrentChina';
import { BookingsCurrentJapan } from '@components/admin/booking/BookingsCurrentJapan';
import { useUser } from '@hooks/queries/useUser';
import { UserHelper } from '@models/User';

export const CurrentBookingsBeforeDeparture: React.FC = () => {
  const user = useUser();
  const isFCChina = user.data ? new UserHelper(user.data).isFCChina : false;
  return (
    <>
      {isFCChina ? (
        <BookingsCurrentChina beforeDeparture={true} />
      ) : (
        <BookingsCurrentJapan beforeDeparture={true} />
      )}
    </>
  );
};
